<template>
  <div>
    <download-excel
      :data="data1"
      :fields="json_fields"
      type="xls"
      name="拼团订单图表.xls"
      :fetch="startDownload"
    
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }"
        >导出Excel</a-button
      >
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template> -->
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a
          href="javascript:;"
          @click="
            gotoDetails(
              `/home/ticketOrder/ticketOrderDetails?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
          >订单详情</a
        >

        <!-- <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >确认领取</a
        > -->
        <!-- <a v-on:click.prevent="showModal">取消订单</a> -->
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { ticketList, ticketListSeach, queryticket } from "@/api/hometwoApi.js";
const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    // sorter: true,
    // width: "10%",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品类型",
    dataIndex: "shopRunTypeStr",
    scopedSlots: { customRender: "shopRunTypeStr" },
  },
  {
    title: "商品名称",
    dataIndex: "tradeName",
    // width: "15%",
    scopedSlots: { customRender: "tradeName" },
  },
  {
    title: "支付金额",
    dataIndex: "pricePay",
    // sorter: true,
    // width: "10%",
    scopedSlots: { customRender: "pricePay" },
  },
  {
    title: "商品封面图",
    dataIndex: "name",
    // sorter: true,
    // width: "10%",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    // sorter: true,
    // width: "10%",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "用户ID",
    dataIndex: "userUid",
    // sorter: true,
    // width: "15%",
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "订单状态",
    dataIndex: "statusUserStr",
    // sorter: true,
    // width: "15%",
    scopedSlots: { customRender: "statusUserStr" },
  },
  {
    title: "下单时间",
    dataIndex: "reserveTime",
    // sorter: true,
    // width: "15%",
    scopedSlots: { customRender: "reserveTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    // sorter: true,
    // width: "15%",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      json_fields: {},
      columns,
      visible: false,
      page: 1,
      limit: 10,
      goodsTypeSonId: 655,
    };
  },
  props: ["formInline"],

  mounted() {
    // this.fetch();
    this.getTicketList();
  },
  methods: {
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const goodsTypeSonId = this.formInline.goodsTypeSonId;
       const userUid = this.formInline.userUid;
      const orderNo = this.formInline.orderNo;
      const shopId = this.formInline.shopId;
      const endDate = this.formInline.endDate;
      const startDate = this.formInline.startDate;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await ticketList(1, 1, goodsTypeSonId, userUid,orderNo, shopId,endDate, startDate);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await ticketList(totalCount, 1, goodsTypeSonId, userUid,orderNo, shopId,endDate, startDate);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await ticketList(pageSize, page, goodsTypeSonId, userUid,orderNo, shopId,endDate, startDate);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath) {
      console.log(operate, "asdadasdasihcasnckxankcxzn");
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      ticketList(
        this.limit,
        this.pagination.current,
        655,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    getTicketList() {
      this.loading = true;
      ticketList(
        this.limit,
        this.page,
        this.goodsTypeSonId,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(this.data);
        console.log(this.data[0].goodsInfo);
        // this.data.forEach((item,index)=>{
        this.loading = false;

        // })
      });
    },

    // 查询
    query() {
      this.loading = true;
      ticketListSeach(
        this.limit,
        this.page,
        655,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then((res) => {
        this.pagination.total = res.count;
        console.log(1111);
        console.log(res);
        this.data = res.data;
        this.loading = false;
      });
    },

    //详情
    gotoDetails(row) {
      console.log(row);
      this.$router.push(row);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/orderManagement/ticketOrder/ticketOrderContent.vue